import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { getMessage } from 'util/locale';
import { convertPlantingPlanParams } from 'util/parse';
import { inferUnit } from 'util/unitConversion';

import HtmlText from 'html-text/HtmlText';
import Explainer from './Explainer';
import PlantingPlanTextInput from './PlantingPlanTextInput';

const baseString = 'vra-planting-plan__average-population';
const CurrentAvgPopulation = ({
  isReviewScriptStep,
  onChangeCurrentAvgPopulation,
  population,
  validationResult
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    'vra-planting-plan-form__fieldset': true
  });

  const { display } = convertPlantingPlanParams({
    validationResult,
    value: population
  });

  return (
    <section className={classString}>
      <div className='vra-planting-plan-form__inputs-wrapper'>
        <PlantingPlanTextInput
          className={`${baseString}__input`}
          dataTestId='current-average-population-input'
          label={getMessage('current-avg-population')}
          onChange={onChangeCurrentAvgPopulation}
          placeholder={getMessage('enter-population')}
          validationResult={validationResult}
          value={display}>
          <span className='vra-planting-plan-form__inputs-units'>
            {inferUnit('seed-density').symbol.quantitySpecific}
          </span>
        </PlantingPlanTextInput>
      </div>
      <Explainer isVisible={!isReviewScriptStep}>
        <HtmlText messageKey='current-avg-population-message' />
      </Explainer>
    </section>
  );
};
CurrentAvgPopulation.propTypes = {
  helpMessage: propTypes.any,
  isReviewScriptStep: propTypes.bool.isRequired,
  onChangeCurrentAvgPopulation: propTypes.func.isRequired,
  population: propTypes.string,
  validationResult: propTypes.object
};
export default CurrentAvgPopulation;
